import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { toolsService } from 'src/services/tools.service'

const useGetFaceScansInfo = () => {
  return useQuery(
    [QUERY_KEYS.FAKE_CONSUMER_SCANS_DATA],
    async () => {
      return toolsService.getFakeConsumerScansData()
    },
    {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      keepPreviousData: false,
    },
  )
}

export { useGetFaceScansInfo }
